export const getHourStringBySpreadsheetColumnIndex = (col: number): string => {
  if (col <= 20) {
    const hour = col - 2 + 5;
    return hour < 10 ? `0${hour}` : `${hour}`;
  }
  return `0${col - 21}`;
};
